import { render, staticRenderFns } from "./batchUpload.vue?vue&type=template&id=08aa9cbe&scoped=true"
import script from "./batchUpload.vue?vue&type=script&lang=js"
export * from "./batchUpload.vue?vue&type=script&lang=js"
import style0 from "./batchUpload.vue?vue&type=style&index=0&id=08aa9cbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa9cbe",
  null
  
)

export default component.exports